<template>
  <header class="bg-white shadow-sm sticky top-0 z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <!-- Logo -->
        <div class="flex items-center">
          <router-link to="/" class="flex-shrink-0 flex items-center hover:opacity-80 transition-opacity">
            <span class="text-2xl">🐱</span>
            <h1 class="ml-2 text-xl font-bold text-primary">{{ $t('brand') }}</h1>
          </router-link>
        </div>
        
        <!-- Desktop Navigation -->
        <nav class="hidden md:block">
          <div class="ml-10 flex items-baseline space-x-8">
            <router-link to="/" class="text-text-primary hover:text-primary px-3 py-2 text-sm font-medium transition-colors">
              {{ $t('nav.home') }}
            </router-link>
            <a href="#games" class="text-text-primary hover:text-primary px-3 py-2 text-sm font-medium transition-colors">
              {{ $t('nav.games') }}
            </a>
            <a href="#categories" class="text-text-primary hover:text-primary px-3 py-2 text-sm font-medium transition-colors">
              {{ $t('nav.categories') }}
            </a>
            <a href="#about" class="text-text-primary hover:text-primary px-3 py-2 text-sm font-medium transition-colors">
              {{ $t('nav.about') }}
            </a>
          </div>
        </nav>
        
        <!-- Right Side Actions -->
        <div class="flex items-center space-x-4">
          <!-- Search Bar -->
          <div class="hidden sm:block">
            <SearchBox />
          </div>
          
          <!-- Language Selector -->
          <LanguageSelector />
          
          <!-- Mobile menu button -->
          <div class="md:hidden">
            <button
              @click="toggleMobileMenu"
              class="text-text-primary hover:text-primary focus:outline-none focus:text-primary"
            >
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Mobile Navigation -->
      <div v-show="mobileMenuOpen" class="md:hidden">
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t">
          <router-link to="/" class="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary">
            {{ $t('nav.home') }}
          </router-link>
          <a href="#games" class="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary">
            {{ $t('nav.games') }}
          </a>
          <a href="#categories" class="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary">
            {{ $t('nav.categories') }}
          </a>
          <a href="#about" class="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary">
            {{ $t('nav.about') }}
          </a>
          
          <!-- Mobile Search -->
          <div class="px-3 py-2">
            <SearchBox />
          </div>
          
          <!-- Mobile Language Selector -->
          <div class="px-3 py-2">
            <div class="text-sm font-medium text-text-secondary mb-2">{{ $t('common.language') }}</div>
            <LanguageSelector />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref } from 'vue'
import LanguageSelector from './LanguageSelector.vue'
import SearchBox from './SearchBox.vue'

export default {
  name: 'Header',
  components: {
    LanguageSelector,
    SearchBox
  },
  setup() {
    const mobileMenuOpen = ref(false)
    
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }
    
    return {
      mobileMenuOpen,
      toggleMobileMenu
    }
  }
}
</script>